import { Navigate, Route, Routes } from 'react-router-dom';
import { PublicLayout } from './site/PublicLayout.js';
import { CaveArea } from './site/CaveArea.js';
import { HomePage } from './site/pages/HomePage.js';
import { AboutPage } from './site/pages/AboutPage.js';
import { JoinPage } from './site/pages/JoinPage.js';
import { CodePage } from './site/pages/CodePage.js';
import { LeavingPage } from './site/pages/LeavingPage.js';
import { LorePage } from './site/pages/LorePage.js';
import { NewsPage } from './site/pages/NewsPage.js';
import { ProfilePage } from './site/pages/ProfilePage.js';
import { LostPage } from './site/pages/LostPage.js';

export function App() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/join" element={<JoinPage />} />
        <Route path="/code" element={<CodePage />} />
        <Route path="/leaving" element={<LeavingPage />} />
        <Route path="/lore" element={<LorePage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/crew/:slug" element={<ProfilePage />} />
        <Route path="/cave/*" element={<CaveArea />} />
        {/* the members' area used to live at the root: keep old bookmarks working */}
        {['leaderboard', 'claims', 'review', 'manage'].map((p) => (
          <Route key={p} path={`/${p}`} element={<Navigate to={`/cave/${p}`} replace />} />
        ))}
        <Route path="*" element={<LostPage />} />
      </Route>
    </Routes>
  );
}
